const ALL_NETWORKS = "All";
//...sigh.
export default class PriceRule {
  constructor(params) {
    this.priceRule = {
      product_code: params.product_code,
      currency_code: params.currency_code,
      network_code: params.network_code,
      account: params.account_id,
      rating_group: params.rating_group,
      price: params.price,
      description: params.description,
      country_code: params.country_code,
      network_country_code: params.network_country_code,
      scheduled_updates: params?.scheduled_updates || [],
      time_last_updated: params?.time_last_updated
    };

    if (this.priceRule.network_code === ALL_NETWORKS) {
      delete this.priceRule.network_code;
      if (!this.priceRule.country_code) {
        this.priceRule.country_code = this.priceRule.network_country_code;
      }
    }
    return this.priceRule;
  }
}
